import { render, staticRenderFns } from "./DetailTextTable.vue?vue&type=template&id=5d37c7e3&scoped=true"
import script from "./DetailTextTable.vue?vue&type=script&lang=js"
export * from "./DetailTextTable.vue?vue&type=script&lang=js"
import style0 from "./DetailTextTable.vue?vue&type=style&index=0&id=5d37c7e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d37c7e3",
  null
  
)

export default component.exports